import { render, staticRenderFns } from "./FmBadgeDemo.vue?vue&type=template&id=60e88aab&"
import script from "./FmBadgeDemo.vue?vue&type=script&lang=js&"
export * from "./FmBadgeDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports